/* eslint-disable */
import Api from '@/api/services/Api';

const route = '/justificacion'

export default {
    get: params => {
        let customRoute = `${route}?expand=status_description&search=${params.filter}`
        switch (params.sexoEstado) {
            case "2": customRoute = `${route}?estado=1&expand=status_description&search=${params.filter}`
                break;
            case "3": customRoute = `${route}?estado=0&expand=status_description&search=${params.filter}`
                break;
            default: break;
        }
        return Api().get(customRoute, { params, crossDomain: true })
    },
    getAll: () => Api().get(`${route}?estado=1`, { crossDomain: true }),
    getAllRecords: () => Api().get(`${route}`, { crossDomain: true }),
    getHistory: payload => Api().get(`${route}/${payload.id}?expand=status_description,history`, { crossDomain: true }),
    post: payload => Api().post(`${route}?expand=status_description`, payload),
    put: payload => Api().put(`${route}/${payload.id}?expand=status_description`, payload),
    delete: payload => Api().delete(`${route}/${payload.id}?expand=status_description`)
}
